const baseStyle = {
    item: {
        color: 'sandstone.10',
        activeBg: 'skyBlue.95',
        hoverBg: 'skyBlue.90',
        selectedBg: 'skyBlue.95',
        px: 2
    },
    heading: {
        color: 'sandstone.45'
    }
};
const defaultProps = {
    size: 'lg',
    variant: 'default'
};
const parts = ['container', 'divider', 'heading', 'icon', 'item', 'text'];
const sizes = {
    sm: {
        icon: {
            size: 'xs'
        },
        item: {
            fontSize: 12,
            h: 24
        },
        heading: {
            fontSize: 12
        }
    },
    md: {
        icon: {
            size: 'sm'
        },
        item: {
            fontSize: 14,
            h: 32
        },
        heading: {
            fontSize: 14
        }
    },
    lg: {
        icon: {
            size: 'md'
        },
        item: {
            fontSize: 16,
            h: 40
        },
        heading: {
            fontSize: 16
        }
    },
    xl: {
        icon: {
            size: 'lg'
        },
        item: {
            fontSize: 18,
            h: 48
        },
        heading: {
            fontSize: 18
        }
    },
    xxl: {
        icon: {
            size: 'xl'
        },
        item: {
            fontSize: 18,
            h: 56
        },
        heading: {
            fontSize: 18
        }
    }
};
const variants = {
    default: {},
    ordered: {
        container: {
            as: 'ol',
            listStyleType: 'decimal',
            pl: 3
        },
        item: {
            display: 'list-item'
        }
    },
    unordered: {
        container: {
            as: 'ul',
            listStyleType: 'disc',
            pl: 3
        },
        item: {
            display: 'list-item'
        }
    },
    // internal; variant *blue* was introduced for the *header* component
    blue: {
        heading: {
            color: 'darkBlue.main'
        }
    }
};
export default {
    baseStyle,
    defaultProps,
    parts,
    sizes,
    variants
};
